import { initAnchorNavigation } from '../../scripts/components/AnchorNavigation';

const SMART_SUBNAV_PARENT_ATTR = 'data-smart-subnav-parent';
const SMART_SUBNAV_ITEM_ATTR = 'data-smart-subnav-item';

export function runSmartSubnav({
  intersectionThreshold = 1,
  intersectionRatio = 0.3,
}) {
  initAnchorNavigation(
    SMART_SUBNAV_PARENT_ATTR,
    SMART_SUBNAV_ITEM_ATTR,
    intersectionThreshold,
    intersectionRatio
  );
}
